import * as R from 'ramda';
var DELIVERY_EVENT = {
  easter: {
    prefix: 'Get',
    name: 'Easter'
  },
  fathers_day: {
    prefix: 'Get',
    name: "Father's day"
  },
  halloween: {
    prefix: 'Get',
    name: 'Halloween'
  },
  mothers_day: {
    prefix: 'Get',
    name: "Mother's day"
  },
  valentines_day: {
    prefix: 'Get',
    name: "Valentine's day"
  },
  christmas: {
    prefix: 'Arrives',
    name: 'Christmas'
  }
};
export var getDeliveryByEventName = function getDeliveryByEventName(deliveryEvent) {
  return DELIVERY_EVENT[deliveryEvent];
};
export var getDeliveryByEventLabel = R.compose(R.ifElse(R.isNil, R.always(''), function (x) {
  return "".concat(x.prefix, " by ").concat(x.name);
}), getDeliveryByEventName);